module.exports = __webpack_public_path__ + "static/img/logo_003.86601690.png";